(() => {
  const loyaltyWidgetSelector = '.gw-rd-loyalty-info-page-widget-placeholder';
  const spendWidgetSelector = '.gw-rd-ways-to-spend-page-widget-placeholder';
  const spendAnchorId = 'ways-to-spend-points';

  let loyaltyWidgetObserver;
  let setupTimer;

  const getSpendWidget = () => document.querySelector(spendWidgetSelector);

  const prepareSpendAnchor = () => {
    const spendWidget = getSpendWidget();

    if (!spendWidget) return null;

    spendWidget.id = spendAnchorId;
    spendWidget.style.scrollMarginTop = 'calc(var(--header-height, 0px) + 72px)';

    return spendWidget;
  };

  const scrollToSpendWidget = (event) => {
    const spendWidget = prepareSpendAnchor();

    if (!spendWidget) return;

    event.preventDefault();
    spendWidget.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const updateRedeemButton = () => {
    const loyaltyWidget = document.querySelector(loyaltyWidgetSelector);
    const widgetRoot = loyaltyWidget?.shadowRoot || loyaltyWidget;
    const actions = widgetRoot?.querySelector('.gw-rd-loyalty-info-page-widget__actions');
    const redeemButton = actions?.querySelector('a, button');

    if (!redeemButton) return false;

    const textNodes = document.createTreeWalker(redeemButton, NodeFilter.SHOW_TEXT);
    let textNode = textNodes.nextNode();

    while (textNode) {
      if (/view\s+rewards/i.test(textNode.nodeValue)) {
        textNode.nodeValue = textNode.nodeValue.replace(/view\s+rewards/i, 'Redeem');
      }

      textNode = textNodes.nextNode();
    }

    redeemButton.setAttribute('aria-label', 'Redeem');
    redeemButton.removeEventListener('click', scrollToSpendWidget, true);
    redeemButton.addEventListener('click', scrollToSpendWidget, true);

    if (redeemButton.tagName === 'A') {
      redeemButton.setAttribute('href', `#${spendAnchorId}`);
    }

    if (widgetRoot !== loyaltyWidget && !loyaltyWidgetObserver) {
      loyaltyWidgetObserver = new MutationObserver(updateRedeemButton);
      loyaltyWidgetObserver.observe(widgetRoot, { childList: true, subtree: true });
    }

    return true;
  };

  const setupRewardPage = () => {
    prepareSpendAnchor();

    if (updateRedeemButton() && setupTimer) {
      window.clearInterval(setupTimer);
      setupTimer = null;
    }
  };

  setupRewardPage();
  setupTimer = window.setInterval(setupRewardPage, 250);
  window.setTimeout(() => {
    if (setupTimer) window.clearInterval(setupTimer);
  }, 60000);

  document.addEventListener('shopify:section:load', setupRewardPage);
})();
